import { render, staticRenderFns } from "./FabledModal.vue?vue&type=template&id=a6cdc9de&scoped=true"
import script from "./FabledModal.vue?vue&type=script&lang=js"
export * from "./FabledModal.vue?vue&type=script&lang=js"
import style0 from "./FabledModal.vue?vue&type=style&index=0&id=a6cdc9de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cdc9de",
  null
  
)

export default component.exports